var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "media-zoom-carousel" }, [
    _c("div", { staticClass: "media-zoom-carousel__container row flex" }, [
      _c(
        "ul",
        { ref: "thumbs", staticClass: "media-zoom-carousel__thumbs m0 p0" },
        _vm._l(_vm.gallery, function(images, index) {
          return _c(
            "li",
            {
              key: images.src,
              staticClass: "media-zoom-carousel__thumb bg-cl-secondary"
            },
            [
              _c("product-image-cloudfront", {
                staticClass: "product-image__content",
                attrs: {
                  "thumbnail-path": images.thumbnail_path,
                  "thumbnail-size": "175",
                  alt: _vm._f("htmlDecode")(_vm.productName)
                },
                on: {
                  click: function($event) {
                    return _vm.navigate(index)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-zoom-carousel__gallery" },
        [
          _c(
            "carousel",
            {
              ref: "zoomCarousel",
              staticClass: "media-zoom-carousel__carousel",
              attrs: {
                "per-page": 1,
                "mouse-drag": false,
                "navigation-enabled": true,
                "pagination-active-color": "#828282",
                "pagination-color": "transparent",
                "navigation-next-label":
                  "<i class='material-icons p15 cl-bg-tertiary pointer'>keyboard_arrow_right</i>",
                "navigation-prev-label":
                  "<i class='material-icons p15 cl-bg-tertiary pointer'>keyboard_arrow_left</i>",
                speed: _vm.carouselTransitionSpeed,
                "navigate-to": _vm.currentPage
              },
              on: { pageChange: _vm.pageChange }
            },
            _vm._l(_vm.gallery, function(images, index) {
              return _c("slide", { key: images.src }, [
                _c(
                  "div",
                  {
                    staticClass: "media-zoom-carousel__slide bg-cl-transparent",
                    class: {
                      "video-container h-100 flex relative": images.video
                    }
                  },
                  [
                    _c("product-image-cloudfront", {
                      staticClass: "product-image__content",
                      attrs: {
                        "thumbnail-path": images.thumbnail_path,
                        "thumbnail-size": "full",
                        alt: _vm._f("htmlDecode")(_vm.productName)
                      },
                      on: {
                        click: function($event) {
                          return _vm.navigate(index)
                        }
                      }
                    }),
                    _vm._v(" "),
                    images.video && index === _vm.currentPage
                      ? _c(
                          "product-video",
                          _vm._b(
                            {
                              attrs: { index: index },
                              on: { "video-started": _vm.onVideoStarted }
                            },
                            "product-video",
                            images.video,
                            false
                          )
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            }),
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }